import { render } from "./ImportImplantStatement.vue?vue&type=template&id=1dadfd34"
import script from "./ImportImplantStatement.vue?vue&type=script&lang=js"
export * from "./ImportImplantStatement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__